import { ReactNode } from 'react';
import clsx from 'clsx';

interface OptionCardProps {
  active: boolean;
  onClick: () => void;
  label: string;
  description?: string;
  icon?: ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  /** Si la card vive en un grupo donde ya hay alguna selección, atenúa el resto */
  groupHasSelection?: boolean;
}

export default function OptionCard({
  active,
  onClick,
  label,
  description,
  icon,
  size = 'md',
  className,
  groupHasSelection,
}: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'group relative rounded-xl2 transition-all duration-200 overflow-visible',
        'flex flex-col items-center justify-center text-center',
        'focus:outline-none',
        size === 'md' ? 'p-5 min-h-[92px]' : 'p-6 min-h-[124px]',
        active
          ? 'bg-gradient-to-b from-elixir-gold/22 to-elixir-gold/8 ring-2 ring-elixir-gold ring-offset-2 ring-offset-elixir-black shadow-[0_8px_24px_-10px_rgba(201,169,97,0.45)]'
          : groupHasSelection
          ? 'bg-gradient-to-b from-elixir-ink/60 to-elixir-black/40 border border-elixir-gold/15 opacity-60 hover:opacity-95 hover:border-elixir-gold/40'
          : 'bg-gradient-to-b from-elixir-ink/80 to-elixir-black/60 border border-elixir-gold/20 hover:border-elixir-gold/55 hover:from-elixir-ink hover:to-elixir-black',
        className
      )}
    >
      {/* Check badge cuando está activo */}
      {active && (
        <span className="absolute -top-2.5 -right-2.5 w-7 h-7 rounded-full bg-elixir-gold text-elixir-black flex items-center justify-center shadow-lg ring-2 ring-elixir-black">
          <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
            <path
              d="M3.5 9.5 L7 13 L14.5 5"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}

      {icon && (
        <div className={clsx('mb-2 transition-colors', active ? 'text-elixir-gold' : 'text-elixir-cream/65')}>
          {icon}
        </div>
      )}
      <span
        className={clsx(
          'serif transition-colors',
          size === 'md' ? 'text-lg' : 'text-xl',
          active ? 'text-elixir-cream font-medium' : 'text-elixir-cream/85'
        )}
      >
        {label}
      </span>
      {description && (
        <span
          className={clsx(
            'text-[11px] mt-1 max-w-[20ch] leading-snug',
            active ? 'text-elixir-cream/85' : 'text-elixir-cream/50'
          )}
        >
          {description}
        </span>
      )}
    </button>
  );
}
